import React, { memo, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Stack, Typography, Pagination } from "investira.react.components";
import services from "../../../../services";
import FilterMetricas from "./EmpresasSection/FilterMetricas";
import ListEmpresasResultado from "./EmpresasSection/ListEmpresasResultado";

const EmpresasSection = memo((props) => {
  const { pessoa } = props;

  const navigate = useNavigate();
  const params = useParams();
  const [pessoas, setPessoas] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    metrica: "pl",
    faixa: "proximos",
    similaridade: "metrica",
  });

  const pageSize = 10;

  const handleFilterChange = (pNewFilters) => {
    setFilters(pNewFilters);
    setPage(1);
  };

  const handleClick = (pEvent, pItem) => {
    navigate(`/empresas/${pItem.pessoa_id}`);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedPessoas = pessoas.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );

  useEffect(() => {
    if (params.pessoa_id) {
      setLoading(true);

      const xParams = {
        ...filters,
        pessoa_id: params.pessoa_id,
      };

      services.pessoas.listSemelhantes(
        {
          ...xParams,
          // size: 30,
          //sort: "relevancia ASC, top_setor_id ASC, setor_id DESC, pessoa_fantasia ASC",
          //sort: "relevancia ASC, setor_id ASC, pessoa_tipo_id ASC, top_setor_id ASC, setor_id DESC",
        },
        (rRes) => {
          setPessoas(Object.values(rRes.data));
          setPage(1);
        },
        null,
        () => {
          setLoading(false);
        },
      );
    }

    //return () => services.pessoas.list.cancel();
  }, [params.pessoa_id, pessoa, filters]);

  // if (pessoas.length === 0) {
  //   console.log(`(DEBUG) Tamanho de pessoas: ${pessoas.length}`);
  //   return null;
  // }

  return (
    <Stack spacing={2} sx={{ py: 2 }}>
      <Stack direction="row">
        <Stack>
          <Typography variant="h6" color="textPrimary" component="h3">
            Empresas Semelhantes
          </Typography>
        </Stack>
        <Stack flexGrow="1"></Stack>
      </Stack>
      <Stack>
        <FilterMetricas values={filters} onChange={handleFilterChange} />
      </Stack>
      <ListEmpresasResultado
        isLoading={isLoading}
        data={paginatedPessoas}
        onClick={handleClick}
        metrica={filters.metrica}
      />
      {pessoas.length > pageSize && (
        <Stack alignItems="center" sx={{ mt: 2 }}>
          <Pagination
            count={Math.ceil(pessoas.length / pageSize)}
            page={page}
            onChange={handleChangePage}
            color="primary"
            size="small"
          />
        </Stack>
      )}
    </Stack>
  );
});

export default EmpresasSection;
